import { useState, useEffect, useContext } from "react";
import AxiosService from "../../utils/AxiosService";
import { AppContext } from "../../context/AppContext";
import MultiLineChart from "../d3Charts/MultiLineChart/MultiLineChart";
import TimeFilter from "../Filter/TimeFilter/TimeFilter";
import { KEY_NAME } from "../../utils/KeyName";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import DateRangeBadge from "../DateRangeBadge/DateRangeBadge";

import "./OtherMetrics.scss";
import { colorArray } from "../../utils/theme";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import DataState from "../DataState/DataState";

const colorList = { otherMetrics: ["#7839EE", "#4BA30D", "#E62E05"] };

const OtherMetricsInner = () => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const [data, setData] = useState(null);
  const [timeRange, setTimeRange] = useState("all");
  const [isMonthPickerOpen, setIsMonthPickerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [monthRange, setMonthRange] = useState({
    from: { year: 2023, month: 0 },
    to: { year: 2024, month: 0 },
  });
  const [rangeLabel, setRangeLabel] = useState("All time data");
  const [showDateRangeBadge, setShowDateRangeBadge] = useState(false);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredData, setFilteredData] = useState(null);

  const axiosService = new AxiosService();
  const { entityName } = useContext(AppContext);

  const timeOptions = [
    { label: "All time data", value: "all" },
    { label: "Custom month range", value: "custom" },
  ];

  const handleFilterData = () => {
    const fromDate = new Date(monthRange.from.year, monthRange.from.month, 1);
    const toDate = new Date(monthRange.to.year, monthRange.to.month + 1, 0);

    const filteredData = data.data[0].values
      .map((item, originalIndex) => ({
        ...item,
        index: originalIndex,
      }))
      .filter((item) => {
        const d = new Date(item.date);
        return d >= fromDate && d <= toDate;
      });

    const startIndex = filteredData?.[0]?.index;
    const arrayLength = filteredData?.length;

    setFilteredData({
      config: data.config,
      data: data.data.map((items, index) => {
        return {
          label: items.label,
          values: items.values.slice(startIndex, startIndex + arrayLength),
        };
      }),
    });
  };

  useEffect(() => {
    if (data) {
      handleFilterData();
    }
  }, [monthRange, timeRange]);

  useEffect(() => {
    if (timeRange === "custom") {
      setIsMonthPickerOpen(true);
    } else {
      setIsMonthPickerOpen(false);
    }

    if (timeRange?.value === "all") {
      setShowDateRangeBadge(false);
    }
  }, [timeRange]);

  useEffect(() => {
    if (data) {
      const startDate = new Date(data.data[0].values[0].date);
      const endDate = new Date(data.data[0].values.slice(-1)[0].date);
      setFilteredData(data);
      setStartDate({
        year: startDate.getFullYear(),
        month: startDate.getMonth(),
      });
      setEndDate({ year: endDate.getFullYear(), month: endDate.getMonth() });
      setMonthRange(() => ({
        from: { year: startDate.getFullYear(), month: startDate.getMonth() },
        to: { year: endDate.getFullYear(), month: endDate.getMonth() },
      }));
    }
  }, [data]);

  useEffect(() => {
    // hasFetched.current = true;
    if (!entityName) return;
    setError(null);

    switch (entityName) {
      case KEY_NAME.FUNDER:
        axiosService
          .getFundersTimeSeriesAll(shortName)
          .then((response) => {
            setData(response.data);
          })
          .catch((err) => {
            console.error("Error:", err);
            setData(null);
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });

        break;
      case KEY_NAME.PUBLISHER:
        axiosService
          .getPublisherTimeSeriesAll(shortName)
          .then((response) => {
            setData(response.data);
          })
          .catch((err) => {
            console.error("Error:", err);
            setData(null);
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      case KEY_NAME.INSTITUTION:
        axiosService
          .getPublisherTimeSeriesAll(shortName)
          .then((response) => {
            setData(response.data);
          })
          .catch((err) => {
            console.error("Error:", err);
            setData(null);
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
        break;

      default:
        break;
    }
  }, [entityName]);

  useEffect(() => {
    setIsLoading(true);
    if (data) {
      setIsLoading(false);
    }
  }, [data]);

  return (
    // <div className="time-series">
    //   <div className="time-series__topbar">
    //     <div className="time-series__filters">
    //       <div className="custom-range-wrapper">
    //         <FilterSelect
    //           label=""
    //           value={timeRange}
    //           options={timeOptions}
    //           onChange={setTimeRange}
    //         />

    //         <MonthRangeDropdown
    //           open={isMonthPickerOpen}
    //           value={monthRange}
    //           onApply={(range) => {
    //             setMonthRange(range);
    //             setIsMonthPickerOpen(false);
    //           }}
    //           onCancel={() => {
    //             setIsMonthPickerOpen(false);
    //             setTimeRange("all");
    //           }}
    //         />
    //       </div>
    //     </div>
    //   </div>

    //   <AnalyticsChartContainer
    //     rawData={rawData}
    //     metricsConfig={metricsConfig}
    //   />
    // </div>
    <div className="other-matrics position-relative">
      <div
        className="other-matrics__topbar  d-flex gap-2"
        style={{ zIndex: 100 }}
      >
        {/* <div className="time-series__filters"> */}
        <div className="other-matrics-custom_range_titer">
          <TimeFilter
            label=""
            width="full"
            startDate={startDate}
            filterValue={timeRange}
            options={timeOptions}
            selectedValue={timeRange}
            onChange={setTimeRange}
            open={isMonthPickerOpen}
            monthRangeValue={monthRange}
            onApply={(range) => {
              setMonthRange(range);
              setIsMonthPickerOpen(false);
              setShowDateRangeBadge(true);
            }}
            onCancel={() => {
              setIsMonthPickerOpen(false);
              setShowDateRangeBadge(false);
              // setTimeRange("all");
              setTimeRange(timeOptions[0]);
            }}
          />
        </div>
        {showDateRangeBadge && (
          <DateRangeBadge
            range={monthRange}
            setTimeRange={setTimeRange}
            setShowDateRangeBadge={setShowDateRangeBadge}
            timeOptions={timeOptions}
          />
        )}
      </div>

      <DataState isLoading={isLoading} error={error} isEmpty={!filteredData}>
        <div className="other-matrics-chart">
          <MultiLineChart
            data={filteredData}
            title="Other Matrics"
            colorArray={colorArray}
          />
        </div>
      </DataState>
    </div>
  );
};

const OtherMetrics = (props) => (
  <ErrorBoundary>
    <OtherMetricsInner {...props} />
  </ErrorBoundary>
);

export default OtherMetrics;
